import ProductDiscountFlex from "./ProductDiscountFlex";
import Taxes from "./Taxes";
import saleLine from "./ModelSaleLine";
import tools from "tools/dates";
import funcs from "tools/functions";
import proxy from "api/proxy";
import { getStorage } from "store/local";
import { PlusCircleIcon } from "components/Icons";

const today = tools.dateToday();
const todayConvert = new Date(today);
const month = todayConvert.setMonth(todayConvert.getMonth() - 1);
const _month = tools.fmtDate2Tryton(new Date(month));
const month_3 = todayConvert.setMonth(todayConvert.getMonth() - 3);
const _month_3 = tools.fmtDate2Tryton(new Date(month_3));
const month_6 = todayConvert.setMonth(todayConvert.getMonth() - 6);
const _month_6 = tools.fmtDate2Tryton(new Date(month_6));

const getAgent = async () => {
  const session = await getStorage("ctxSession");
  let agent = session.agent;
  if (!agent) {
    const { data } = await proxy.search(
      "commission.agent",
      [["user", "=", session.user]],
      ["rec_name"],
    );
    agent = data[0];
  }
  return agent;
};

const getSaleDevice = () => {
  const terminal = funcs.getCookie();
  if (terminal?.device_id) {
    return { id: parseInt(terminal.device_id, 10), name: terminal.device_name };
  }
  return null;
};

const searchParty = (value) => {
  const session = getStorage("ctxSession");
  const search = [["OR", ["agents.agent.user", "=", session.user]]];
  if (value) {
    const dom = [
      "OR",
      ["name", "ilike", `%${value}%`],
      ["id_number", "ilike", `${value}%`],
    ];
    search.push(dom);
  }
  return search;
};

const getAddress = (value, record) => {
  const party_id = record?.party?.id ?? -1;

  const dom = [["party", "=", party_id]];
  if (value?.length > 2) {
    dom.push(["rec_name", "ilike", `%${value}%`]);
  }
  return dom;
};

const onChangeAddress = (activeRec, storeRec) => {
  storeRec.invoice_address = storeRec.shipment_address;
  activeRec.invoice_address = activeRec.shipment_address;
};

const onChangeParty = async (record, store) => {
  const party = record.party;
  if (party) {
    store.payment_term = party["customer_payment_term."];
    record.payment_term = party["customer_payment_term."];
    const priceList = party["sale_price_list."];
    store.price_list = priceList?.id;
    record.price_list = priceList;
    let invoice_type = "1";
    if (party.invoice_type) {
      invoice_type = party.invoice_type;
    }
    if (!party["customer_payment_term."]) {
      const defaultPayment = await defaultPaymentTerm();
      store.payment_term = defaultPayment;
      record.payment_term = defaultPayment;
    }

    store.invoice_type = invoice_type;
    record.invoice_type = invoice_type;
  }
};

const defaultPaymentTerm = async () => {
  const { data } = await proxy.search(
    "account.invoice.payment_term",
    ["payment_type", "=", 1],
    ["name"],
    1,
  );
  return data[0];
};
const getFilters = () => {
  const session = getStorage("ctxSession");

  return {
    today: [
      [
        "OR",
        ["sale_date", "=", `${today}`],
        ["create_date", ">=", `${today} 00:00:00`],
      ],
      ["agent.user", "=", session.user],
    ],
    month: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month}`],
      ],
      ["agent.user", "=", session.user],
    ],
    month_3: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month_3}`],
      ],
      ["agent.user", "=", session.user],
    ],
    month_6: [
      [
        ["sale_date", "<=", `${today}`],
        ["sale_date", ">=", `${_month_6}`],
      ],
      ["agent.user", "=", session.user],
    ],
  };
};

const getTotalAmount = (record) => {
  let totalAmount = 0;
  if (!record.lines && record.total_amount) return record.total_amount;
  record?.lines?.forEach((item) => {
    totalAmount = totalAmount + parseFloat(item.amount_w_tax);
  });
  return totalAmount;
};

const getUntaxedAmount = (record) => {
  let totalAmount = 0;
  record?.lines?.forEach((item) => {
    totalAmount =
      totalAmount +
      parseFloat(
        item.amount ?? parseFloat(item.quantity) * parseFloat(item.unit_price),
      );
  });
  return totalAmount;
};

const getVisible = (_, record) => {
  if (record?.state !== "draft" && record?.number) return false;
  return true;
};

const getVisibleDraft = (_, record) => {
  if (record?.state === "quotation" && record?.number) return true;
  return false;
};

let lastLoadedSaleId = null;
const initialLinesBySale = new Map();

const snapshotLines = (lines) =>
  lines
    ? [...lines.entries()].map(([id, line]) => ({
        id,
        quantity: line?.quantity,
        unit_price: line?.unit_price,
        product: { name: line?.product?.name },
      }))
    : [];

const onRecordLoaded = (record) => {
  if (!record?.id || record.id < 0) return;
  if (lastLoadedSaleId !== record.id) {
    initialLinesBySale.clear();
    lastLoadedSaleId = record.id;
  }
  if (!initialLinesBySale.has(record.id)) {
    initialLinesBySale.set(record.id, snapshotLines(record.lines));
  }
};

const createNote = async (record) => {
  if (!record?.id || record.id < 0) return;

  const notas = [];
  const linesBefore = initialLinesBySale.get(record.id) ?? [];
  const byId = new Map(linesBefore.map((line) => [line.id, line]));
  const linesNow = record.lines;
  const byIdNow = new Map(linesNow.entries());

  for (const [id, line] of linesNow) {
    const prev = byId.get(id);
    const name = line.product?.name ?? prev?.product?.name ?? id;
    if (!prev) {
      const total =
        line.amount_w_tax ??
        line.untaxed_amount ??
        Number(line.quantity) * Number(line.unit_price);
      notas.push(`Agregada: ${name} x${line.quantity} -> ${total}`);
      continue;
    }
    const prevQty = Number(prev.quantity);
    const nowQty = Number(line.quantity);
    if (prevQty !== nowQty) {
      notas.push(
        `Modificado cantidad en ${name}: antes ${prevQty} ahora ${nowQty} unidades`,
      );
    }
    const prevPrice = Number(prev.unit_price ?? 0);
    const nowPrice = Number(line.unit_price ?? 0);
    if (prevPrice !== nowPrice) {
      notas.push(
        `Modificado precio en ${name}: antes ${prevPrice} ahora ${nowPrice}`,
      );
    }
  }

  for (const line of linesBefore) {
    if (!byIdNow.has(line.id)) {
      notas.push(`Eliminada: ${line.product?.name ?? line.id}`);
    }
  }

  if (notas.length === 0) return;

  const text = notas.join("\n");

  const { error } = await proxy.create(
    "ir.note",
    {
      resource: `sale.sale,${record.id}`,
      message: text,
      unread: true,
    },
    ["id"],
  );
  if (error) {
    console.error("Error al guardar la nota:", error);
  }
};

// const getVisibleConfirm = (name, record) => {
//   return record?.state === "quotation";
// };

const getReadonly = (record) => {
  if (record?.number || record.state !== "draft") return true;
  return false;
};

const getReadonlyLines = (record) => {
  if (record?.state && !["draft"].includes(record.state)) return true;
  return false;
};

const getReadonlyListPrice = (record) => {
  if (record?.number || record.state !== "draft" || record?.price_list)
    return true;
  return false;
};

const disabledEdit = (record) => {
  let res = false;
  if (record.state === "draft") {
    res = true;
  }
  return res;
};

const stateColors = {
  draft: "slate",
  quotation: "amber",
  processing: "sky",
  done: "lime",
  canceled: "rose",
};

const getView = (config) => {
  const session = getStorage("ctxSession");
  const warehouse = config?.agent?.["user."]?.warehouse;
  const DictCtxView = {
    selectable: false, // options: multi - one - false
    activeSearch: true,
    filters: getFilters,
    access: { edit: disabledEdit },
    domain: [
      ["sale_date", "=", today],
      ["agent.user", "=", session.user],
    ],
    form_action: ["add", "edit"],
    table_action: ["add", "open"],
    model: "sale.sale",
    onRecordLoaded: onRecordLoaded,
    onSaved: createNote,
    note: true,
    tags: {
      state: stateColors,
    },
    reports: [
      {
        name: "sale.sale",
        description: "sale.sale.description.report",
        send_print: true,
        // send_email: "send_email",
      },
    ],
    webfields: {
      number: { type: "char", readOnly: true, searchable: true },
      party: {
        type: "many2one",
        model: "party.party",
        recSearch: searchParty,
        withChange: onChangeParty,
        required: true,
        readOnly: getReadonly,
        attrs: [
          "invoice_type",
          "sale_price_list",
          "sale_price_list.name",
          "customer_payment_term",
          "customer_payment_term.name",
          "customer_tax_rule",
        ],
        searchable: true,
        dependents: ["price_list", "payment_term"],
      },
      warehouse: {
        type: "many2one",
        model: "stock.warehouse",
        default: warehouse,
        visible: () => false,
      },
      sale_device: {
        type: "many2one",
        model: "sale.device",
        recSearch: () => [],
        default: getSaleDevice,
      },
      sale_date: {
        type: "date",
        readOnly: getReadonly,
        // readOnly: { state: ["quotation"] },
      },
      shipment_date: {
        type: "date",
        required: false,
        readOnly: getReadonly,
      },
      shipment_address: {
        type: "many2one",
        model: "party.address",
        recSearch: getAddress,
        withChange: onChangeAddress,
        required: true,
        readOnly: getReadonly,
      },
      agent: {
        type: "many2one",
        model: "commission.agent",
        default: getAgent,
        readOnly: true,
      },
      price_list: {
        type: "many2one",
        model: "product.price_list",
        readOnly: getReadonlyListPrice,
        // recSearch: () => "[]",
      },
      payment_term: {
        type: "many2one",
        model: "account.invoice.payment_term",
        readOnly: getReadonlyListPrice,
        default: defaultPaymentTerm,
      },
      state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "draft",
        tags: stateColors,
      },
      invoice_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      shipment_state: {
        type: "char",
        readOnly: true,
        translate: true,
      },
      reference: {
        type: "char",
        readOnly: getReadonly,
      },
      // invoice_type: {
      //   type: "radio",
      //   default: "1",
      //   options: [
      //     { value: "P", text: "POS" },
      //     { value: "1", text: "ELECTRONICA" },
      //   ],
      //   readOnly: getReadonly,
      // },
      add_discount: {
        type: "button_custom_modal",
        Component: ProductDiscountFlex,
        color: "blue",
        icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
        visible: () => {
          return config?.modules_activated?.includes("sale_discount_flex");
        },
        button_ok: false,
        resetWizard: false,
      },
      lines: {
        type: "one2many",
        model: "sale.line",
        ctxView: saleLine.ctxView(config),
        required: true,
        readOnly: getReadonlyLines,
      },
      sale_taxes: {
        type: "custom",
        component: Taxes,
        colspan: "col-span-2",
        // ctxView: ctxViewTaxes,
        readOnly: true,
        search: true,
      },
      total_amount_cache: {
        type: "numeric",
        readOnly: true,
        function: getTotalAmount,
        search: true,
      },
      untaxed_amount: {
        type: "numeric",
        readOnly: true,
        function: getUntaxedAmount,
        search: true,
        decimalPlaces: 2,
      },
      total_amount: {
        type: "numeric",
        readOnly: true,
        function: getTotalAmount,
        search: true,
        decimalPlaces: 2,
      },
      comment: {
        type: "text",
        readOnly: getReadonly,
        colspan: "col-span-2",
      },
      description: {
        type: "char",
        readOnly: getReadonly,
      },
      quote: {
        type: "button",
        button_method: "quote",
        visible: getVisible,
        // save: true,
      },
      draft: {
        type: "button",
        button_method: "draft",
        visible: getVisibleDraft,
        color: "rose",
        // save: true,
      },
      // confirm: {
      //   type: "button",
      //   button_method: "confirm",
      //   visible: getVisibleConfirm,
      // },
    },
    webtree: [
      { name: "number", width: "20%" },
      { name: "agent", width: "20%" },
      { name: "sale_date", width: "20%" },
      { name: "party", width: "35%" },
      { name: "total_amount", width: "10%" },
      { name: "invoice_state", width: "10%" },
      { name: "shipment_state", width: "10%" },
      { name: "state", width: "10%", widget: "badge" },
    ],
    webform: [
      { name: "agent" },
      {
        id: "infoSale",
        grid: [
          { name: "shipment_date" },
          { name: "reference" },
          { name: "number" },
        ],
        size: [1, 3],
        span: "col-span-1",
      },
      { name: "party" },
      { name: "shipment_address" },
      {
        id: "infoPrice",
        grid: [{ name: "price_list" }, { name: "payment_term" }],
        size: [1, 2],
        span: "col-span-1",
      },
      // {
      //   id: "infoSale2",
      //   grid: [, { name: "invoice_type" }],
      //   size: [1, 2],
      //   span: "col-span-1",
      // },
      { name: "description" },
      { name: "add_discount" },
      { name: "lines", component: "modal" },
      {
        id: "footerSale",
        grid: [{ name: "sale_taxes" }],
        size: [1, 2],
        span: "col-span-2",
      },
      {
        id: "amounts",
        grid: [
          { name: "untaxed_amount" },
          { name: "total_amount" },
          { name: "state" },
        ],
        size: [1, 3],
        span: "col-span-2",
      },
      {
        id: "comment",
        grid: [{ name: "comment" }],
        size: [1],
        span: "col-span-1",
      },
      {
        id: "buttonsSale",
        grid: [
          { name: "quote" },
          // { name: "confirm" },
          { name: "draft" },
        ],
        size: [1, 2],
        span: "col-span-3",
      },
    ],
  };

  return DictCtxView;
};

export default { ctxView: getView };
